<template>
  <div>
    <div v-if="fullAddress" class="mb-1">
      <span class="application-heading wrap-content">Address: </span>
      {{ fullAddress }}
    </div>
    <div v-if="country && country.name" class="mb-1 countries-list">
      <span class="application-heading">Country: </span>
      <span v-if="!country.flagUrl"></span>
      <DetailsListItemCountryChip
        v-if="
          country.countryAlpha2Code &&
          country.name &&
          country.flagUrl &&
          country.shortDisplayName
        "
        :key="country.countryAlpha2Code"
        :name="country.name"
        :code="country.countryAlpha2Code.toUpperCase()"
        :short-display-name="country.shortDisplayName"
        :flagUrl="country.flagUrl"
        theme="dark"
      ></DetailsListItemCountryChip>
    </div>
    <div v-if="latLon" class="mb-1">
      <span class="application-heading">Lat/Lon: </span>
      {{ latLon }}
    </div>
    <div v-if="customFields" class="mb-1">
      <div v-for="(value, key, $index) in customFields" :key="$index">
        <span class="application-heading"
          >{{ getCustomFieldLabel(key) }}:
        </span>
        <span class="wrap-content">{{ value }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { upperCaseFirstLetter } from "@/common/basic.utilities";
export default {
  name: "AssetsPaneDetails",
  components: {
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
  },
  props: {
    assetDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullAddress() {
      return this.assetDetails?.fullAddress;
    },
    country() {
      return this.assetDetails?.country;
    },
    latLon() {
      const { latitude, longitude } = this.assetDetails;
      return latitude && longitude
        ? `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`
        : null;
    },
    customFields() {
      return this.assetDetails?.customFields;
    },
  },
  methods: {
    getCustomFieldLabel(label) {
      return label ? upperCaseFirstLetter(label) : label;
    },
  },
};
</script>
<style scoped>
.wrap-content {
  white-space: normal;
  word-wrap: break-word;
}
.countries-list {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}
</style>
